import { useEffect, useState } from 'react';
import api from '../config/api';
import useStore from '../config/store';

/**
 * ¿La organización tiene WhatsApp? (2026-10-26) Número propio, o el número
 * compartido de Grafton si un super-admin se lo permitió. Consulta
 * GET /captation/whatsapp-info?organizationId= cuando `active` pasa a true
 * (al abrir un diálogo).
 *
 * Mientras carga, o si la consulta falla, se asume disponible: el backend
 * igual rechaza el envío y el diálogo muestra su mensaje.
 *
 * @param {boolean} active
 * @returns {{ usable: boolean, channel: string|null, number: string|null, loading: boolean }}
 */
const useWhatsappChannel = (active = true) => {
  const [state, setState] = useState({ usable: true, channel: null, number: null, loading: false });

  useEffect(() => {
    if (!active) return undefined;
    const { organization, authToken } = useStore.getState();
    if (!organization) return undefined;
    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true }));
    api.get('/captation/whatsapp-info', {
      params: { organizationId: organization },
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then((res) => {
        if (cancelled) return;
        const data = res.data?.response?.data || {};
        setState({
          usable: data.usable !== false,
          channel: data.channel || null,
          number: data.number || null,
          loading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setState((prev) => ({ ...prev, loading: false }));
      });
    return () => { cancelled = true; };
  }, [active]);

  return state;
};

export default useWhatsappChannel;
